import { DynamicHeadline } from "../DynamicHeadline"
import Section, { parseColors } from "../Section"
import styles from "./DividerHeadline.module.scss"

const DividerHeadline = ({ data = {}, colors }) => {
  const {
    dynamic_headline: dynamicHeadline,
    headline_type: headlineType,
    headline_appearance: headlineAppearance,
    ankerslug,
  } = data

  const { accent } = parseColors({ colors })

  return (
    <Section
      sectionSpacing={{
        top: data?.section_padding_top?.value || null,
        bottom: data?.section_padding_bottom?.value || null,
      }}
      id={ankerslug}
      colors={colors}
    >
      <div className={styles.wrapper}>
        <DynamicHeadline
          className={styles.headline}
          headlineType={headlineType.value}
          headlineAppearance={headlineAppearance.value}
        >
          {dynamicHeadline}
        </DynamicHeadline>
        <div
          style={{ backgroundColor: accent.color }}
          className={styles.square}
        />
      </div>
    </Section>
  )
}

export default DividerHeadline
